export default {
  CASES_TABLE: {
    CASE_QUICK_FILTERS: {
      all: 'All cases',
      todo: 'To-do',
      todo_admin: 'Admin',
      todo_attorney: 'Attorney',
    },
    ERROR_MESSAGES: {
      ERROR_WHILE_LOADING_CASES: 'An error occurred while loading cases!',
      ERROR_WHILE_LOADING_PARTNERS: 'An error occurred while loading partners!',
      ERROR_WHILE_LOADING_STATES: 'An error occurred while loading states!',
      ERROR_WHILE_EXPORTING_CASES: 'An error occurred while exporting cases!',
    },
    EXPORT: {
      BUTTON: 'Export cases (Excel)',
      FILENAME: 'cases-export',
    },
    FILTERS: {
      APPLY: 'Apply',
      STAGE_LABEL: 'Main state',
      CASE_ID: {
        LABEL: 'Case ID',
        PLACEHOLDER: 'Start typing...'
      },
      DEBTOR_NAME: {
        LABEL: 'Debtor',
        PLACEHOLDER: 'Start typing...'
      },
      CLIENT: {
        LABEL: 'Client',
        PLACEHOLDER: 'Start typing...',
      },
      PARTNER: {
        LABEL: 'Partner',
        PLACEHOLDER: 'Start typing...',
      },
      PRODUCT: {
        LABEL: 'Product',
        PLACEHOLDER: 'Select product...',
        NOTICE: 'Payment Notice',
        DEMAND_LETTER: 'Demand Letter',
        HARD_1: 'Payment Order',
        HARD_2: 'Payment Order - Execution',
        COFACE: 'Coface',
      },
      STAGE: {
        DRAFT: 'Draft',
        ONGOING: 'Ongoing',
        CLOSED: 'Closed',
      },
      STATE: {
        LABEL: 'State',
        PLACEHOLDER: 'Start typing...',
      },
      STARTED_AT: {
        LABEL: 'Start date',
        MIN_LABEL: 'Start date (from)',
        MAX_LABEL: 'Start date (to)',
      },
      TRANSITION_AT: {
        LABEL: 'Event date',
        MIN_LABEL: 'Event date (from)',
        MAX_LABEL: 'Event date (to)',
      },
      "CLEAR_ALL": "Clear filters"
    },
    TABLE_INFO: {
      CLOSED: 'Closed cases',
      CLOSED_INFO:
        'These are cases that have either been successfully paid or closed for other reasons.',
      DRAFT: 'Drafts',
      DRAFT_INFO:
        'These are cases that you paused. If you arrived here by clicking the "Lawyer and Legal Solutions" link from your Számlázz.hu account on a Számlázz.hu invoice, each click created a draft.',
      ONGOING: 'Ongoing cases',
      ONGOING_INFO:
        'These are cases that have been successfully initiated and are currently in progress. If you have any tasks for any of them, we will notify you by email.',
    },
    HEADERS: {
      CASE_ID: 'Case ID',
      REMAINING_CLAIMS: 'Remaining Claims',
      ORIGINAL_CLAIMS: 'Claim',
      PAYMENT_STATUS: 'Payment status',
      PARTIES: 'Parties',
      CLIENT: 'Creditor',
      STATE: 'State',
      STARTED_AT: 'Started at',
      EXPECTED_TRANSITION: 'Expected status',
      LAST_EVENT: 'Last event',
      DEADLINE: 'Deadline',
    },
    MORE_CURRENCIES: '+{{count}} more',
    COUNTDOWN: '{{hours}} hours {{minutes}} minutes',
    COUNTDOWN_WITH_DAYS: '{{days}} days {{hours}} hours {{minutes}} minutes',
    COUNTDOWN_UNTIL: 'Complete by',
    COUNTDOWN_OVERDUE: 'Ending soon',
    CASE_ACTIONS: {
      DOWNLOAD_DOCUMENTS: 'Download documents',
      DELETE: 'Delete case',
      EDIT: 'Edit case',
      PAY_WITH_CARD: 'Pay with card',
      RESEND_PROFORMA: 'Resend proforma',
      RESEND_PROFORMA_CONFIRM: 'The fees will change. After saving, do you want to resend the pro forma to the creditor?',
      RESEND_PROFORMA_SUCCESS: 'Proforma resend requested successfully.',
      RESEND_PROFORMA_ERROR: 'Could not resend the pro forma.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK: 'Create invoice task',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_CONFIRM: 'The notary procedural fees will decrease. After saving we will create an Asana task about the refund.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_INCREASE_CONFIRM: 'The notary procedural fees will increase. After saving we will send a pro forma to the creditor.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_SUCCESS: 'Asana task created successfully.',
      CREATE_FEE_CHANGE_INVOICE_ASANA_TASK_ERROR: 'Could not create the Asana task.',
      BAILIFF_CONTACT: 'Bailiff contact',
      SEARCH_PLACEHOLDER: 'Search...',
      NO_ACTIONS: 'No available actions',
    },
    START_PAYMENT_CHOICE: {
      TITLE: 'Pay the case initiation fee',
      DESCRIPTION: 'Please choose how you would like to pay the case initiation fee. ',
      MORE_INFO: 'Read more about the case initiation fee',
      CARD_TITLE: 'Payment with credit card',
      CARD_DESCRIPTION: 'Secure and fast',
      TRANSFER_TITLE: 'Payment with wire transfer (pro-forma invoice)',
      TRANSFER_DESCRIPTION: '48 hours lead time',
      CREDIT_TITLE: 'Pay with credits',
      CREDIT_DESCRIPTION: 'From your prepaid balance',
      SUBMIT_CARD: 'Pay by card',
      SUBMIT_TRANSFER: 'Request a pro-forma invoice',
      SUBMIT_CREDIT: 'Pay with credits',
      TOOLTIP: 'Pay the case initiation fee',
    },
    TRANSFER_INSTRUCTIONS: {
      TITLE: 'We have sent you the pro-forma invoice and transfer details in email.',
      DESCRIPTION: 'We will process your transfer within 24 hours and start your case.',
      AMOUNT_LABEL: 'Amount to transfer',
      BENEFICIARY_LABEL: 'Account holder',
      ACCOUNT_NUMBER_LABEL: 'Bank account number',
      REFERENCE_LABEL: 'Reference',
      BUTTON_LABEL: 'Proceed',
    },
    ACTION_GROUPS: {
      CASE_ACTIONS: 'Operations',
      NO_ITEMS: 'No items in this group',
    },
    CASE_DETAILS: {
      DETAILS_LABEL: 'Details',
      EVENTS_LABEL: 'Events',
    },
    NO_CASES: {
      TITLE: 'No cases found with the given criteria',
    },
    ACCESSORY_CLAIM: 'accessory claim',
    PAYMENT_STATUS: {
      PARTIAL: 'Partial payment',
      FULL: 'Full payment',
    },
    TOOLTIP: {
      ADDRESS_LABEL: 'Address',
      TAX_NUMBER_LABEL: 'Tax number',
      EXPECTED_EVENT: 'Next status: {{event}}',
      DEADLINE: 'Deadline: {{date}}',
      DEADLINE_OVERDUE: 'Deadline: {{date}} expired',
      EXPECTED_TRANSITION_TIMING_UPCOMING: 'At: {{date}}',
      EXPECTED_TRANSITION_TIMING_OVERDUE: 'Soon',
    },
    COPY_SUCCESS: "Case identification copied to clipboard",
    CIVIL_LAWSUIT_DIALOG: {
      TITLE: 'Starting court proceedings',
      INTRO_PARTIAL:
        'Debtor {{debtorName}} partially disputed the content of the payment order.',
      INTRO_FULL:
        'Debtor {{debtorName}} disputed the content of the payment order in full, so the notary considers the order-for-payment procedure closed.',
      INSTRUCTIONS_PARTIAL:
        'You may enforce the disputed portions by starting a lawsuit by {{deadline}}. Appointing legal representation is required; we recommend contacting the partner law firm below.',
      INSTRUCTIONS_FULL:
        'You can continue the case by starting a lawsuit by {{deadline}} to enforce your claim. Appointing legal representation is required; we recommend contacting the partner law firm below.',
      LAW_FIRM_HEADING: 'Partner law firm',
      CLOSE: 'Close',
      LINK_TOOLTIP: 'Civil lawsuit – contact and next steps',
    },
    DOWNLOAD_DOCUMENTS_DIALOG: {
      TITLE: 'Download case documents',
      DESCRIPTION: 'Select which documents to include in the zip file.',
      EVENT_ATTACHMENTS: 'Event attachments ({{count}})',
      LEGAL_RELATIONSHIP_CONTRACT: 'Legal relationship contract ({{count}})',
      CLAIM_FILES: 'Claim files ({{count}})',
      DOWNLOAD: 'Download zip',
      CANCEL: 'Cancel',
      NO_DOCUMENTS: 'This case has no downloadable documents.',
      LOAD_ERROR: 'Could not load case documents.',
      DOWNLOAD_ERROR: 'Could not download case documents.',
    },
  },
};
